'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.LogLevel = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LogLevel = exports.LogLevel = function (_Component) {
	_inherits(LogLevel, _Component);

	function LogLevel() {
		_classCallCheck(this, LogLevel);

		return _possibleConstructorReturn(this, (LogLevel.__proto__ || Object.getPrototypeOf(LogLevel)).apply(this, arguments));
	}

	_createClass(LogLevel, [{
		key: 'render',
		value: function render() {
			var levelText = LogLevel.levels[this.props.level];
			return React.createElement(
				'span',
				{
					className: 'loglevel, loglevel_' + this.props.level },
				levelText
			);
		}
	}]);

	return LogLevel;
}(_react.Component);

LogLevel.levels = ['Debug', 'Info', 'Warning', 'Error', 'Fatal'];


//////////////////
// WEBPACK FOOTER
// ./js/Components/LogLevel.js
// module id = 603
// module chunks = 0